<template>
  <a-modal
    :title="title"
    :width="500"
    :ok=false
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    :okText="this.$store.getters.language['common.okButton']"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']">

    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" style="margin-bottom: 0">
          <a-form-model-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            style="margin-bottom: 0"
            :label="language['eletronicSigned.cancelOrTerminationCause']">
            <!--<a-textarea  v-model="comments" :max-Length="5" rows="4"/>-->
            <textarea v-model="comments" style="width:100%;border-radius: 5px;line-height: 1.5;" rows="5" cols="25" maxLength="1000" > </textarea>
          </a-form-model-item>

      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>

  import MyTodoForm from './MyTodoForm';
  import {putAction, getFileAccessHttpUrl,getAction,postAction} from '@/api/manage';

  export default {
    name: 'MyTodoCommentsModal',
    components: {
      MyTodoForm
    },
    /*this.language['eletronicSigned.termination']*/
    /*props:{
      title: {
        type: String,
        default: '1'
      },
    },*/
    data() {
      return {
        title:'',
        url:'',
        comments:'',
        model:{},
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading:false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 2 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      add() {
        /*this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.add();
        })*/
      },
      edit(record) {
        /*this.pfBpmProcessId = record.pfBpmProcessId;
        this.workNo = record.workNo;
        this.approveAction = record.approveAction;
        this.taskCode = record.taskCode;*/
        this.title = record.title;
        this.comments = "";
        this.url = record.url;
        this.model = Object.assign({}, record)
        this.visible = true

      },
      close() {
        this.$emit('reSeach');
        this.$emit('close');
        this.visible = false;
      },
      handleOk() {
        // this.$refs.realForm.submitForm();
        this.tocancel()
      },
      tocancel(){
        let query = this.model;
        query.comments = this.comments.trim()
        if(query.comments===null||query.comments===''||query.comments===undefined){
          this.$message.warning(this.title + this.language['eletronicSigned.cancelOrTerminationCauseNotNull']);
          return;
        }
        this.confirmLoading = true;
        if(this.model.httptype==='Get'){
          getAction(this.url, query).then((res) => {
            this.confirmLoading = false;
            if (res.success) {
              this.close()
            } else {
              this.$message.warning(res.message);
            }
          })
        }else if(this.model.httptype==='Post'){
          postAction(this.url, query).then((res) => {
            this.confirmLoading = false;
            if (res.success) {
              this.close()
            } else {
              this.$message.warning(res.message);
            }
          })
        }

      },
      submitCallback() {
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel() {
        this.close()
      }
    }
  }
</script>